'use client';

// Останній рубіж — спрацьовує коли падає САМ root layout (провайдери/токени недоступні),
// тож усе інлайн і самодостатнє. Мова — з cookie, дефолт uk.
import { useEffect } from 'react';

const TXT: Record<string, { title: string; desc: string; retry: string }> = {
  uk: { title: 'Щось пішло не так', desc: 'Сталася критична помилка. Спробуйте перезавантажити сторінку.', retry: 'Перезавантажити' },
  ru: { title: 'Что-то пошло не так', desc: 'Произошла критическая ошибка. Попробуйте перезагрузить страницу.', retry: 'Перезагрузить' },
  en: { title: 'Something went wrong', desc: 'A critical error occurred. Please try reloading the page.', retry: 'Reload' },
};

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => { console.error(error); }, [error]);
  const lang = (typeof document !== 'undefined' && (document.cookie.match(/(?:^|; )lang=(\w+)/)?.[1])) || 'uk';
  const s = TXT[lang] ?? TXT.uk;

  return (
    <html lang={lang}>
      <body style={{ margin: 0, background: '#0a0a0e', color: '#e8e8ef', fontFamily: "'Inter', system-ui, sans-serif" }}>
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px 20px', gap: 16 }}>
          <div style={{
            width: 88, height: 88, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'rgba(240,90,90,.12)', border: '1px solid rgba(240,90,90,.3)', color: '#f05a5a', fontSize: 40, fontWeight: 700,
          }}>!</div>
          <h1 style={{ fontSize: 26, fontWeight: 800, margin: 0, fontFamily: "'Space Grotesk', 'Inter', sans-serif" }}>{s.title}</h1>
          <p style={{ fontSize: 15, color: '#9a9aa8', maxWidth: 420, margin: 0, lineHeight: 1.6 }}>{s.desc}</p>
          {error?.digest && <code style={{ fontSize: 11, color: '#6a6a78', fontFamily: 'monospace' }}>#{error.digest}</code>}
          <button onClick={reset} style={{
            marginTop: 8, padding: '12px 24px', borderRadius: 12, border: 'none',
            background: '#3ddc84', color: '#06281c', fontSize: 14, fontWeight: 800, cursor: 'pointer',
            fontFamily: 'inherit', boxShadow: '0 0 22px rgba(61,220,132,.35)',
          }}>{s.retry}</button>
        </div>
      </body>
    </html>
  );
}
